import { ProjectType } from '../../../../../types/project';
import { FileFormat } from '../../../types';

const showTriggerBlacklist = [
    FileFormat.iosSdk,
    FileFormat.androidSdk,
    FileFormat.appleStringsdict,
    FileFormat.jsonI18Next,
    FileFormat.gettextPot,
    FileFormat.php,
    FileFormat.dfflineXliff,
    FileFormat.integrationData,
];
export const isTriggerVisible = (fileFormat: FileFormat, projectType: ProjectType) =>
    !showTriggerBlacklist.includes(fileFormat) && projectType !== ProjectType.pagedDocuments;

export const isCustomFileAndFolderStructureVisible = (fileFormat: FileFormat, projectType: ProjectType | undefined) =>
    fileFormat !== FileFormat.androidSdk &&
    fileFormat !== FileFormat.flutterSdk &&
    projectType === ProjectType.localizationFiles;
